<template>
    <div>
        <simple-layout vertical>
            <simple-layout horizontal>
                <basic-card style="margin-bottom: 0px;">
                    <template slot="header">Payment batch</template>
                    <form-wrapper>
                        <form-text-input caption="Name" v-model="paymentBatch.displayName"/>
                        <form-text-input caption="Description" v-model="paymentBatch.description"/>
                        <form-date-input caption="Planned payment date" v-model="paymentBatch.plannedPaymentDate"/>
                    </form-wrapper>
                    <simple-button @press="savePaymentBatch" v-if="editable">{{$t("save")}}</simple-button>
                </basic-card>
                <basic-card style="margin-bottom: 0px;">
                    <template slot="header">
                        Batch workflow
                    </template>
                    <data-table
                            :data="paymentBatch.states"
                            :configuration="paymentBatchWorkflowConfiguration"
                            component-id="payment-batch-states-list"
                    />
                </basic-card>
            </simple-layout>
            <simple-layout>
                <basic-card v-if="paymentsByBatch(paymentBatch.id) != undefined && paymentsByBatch(paymentBatch.id).length > 0">
                    <template slot="header">Payment batch summary</template>
                    <data-table
                            :data="paymentsOverview"
                            :configuration="paymentsOverviewTableConfig"
                            component-id="payment-overview"
                    />
                </basic-card>
                <basic-card>
                    <template slot="header">Payments</template>
                    <data-table
                            :data="paymentsByBatch(paymentBatch.id)"
                            :configuration="paymentsTableConfiguration"
                            @focusedChanged="handleFocusChanged"
                            @add="handleAdd"
                            @delete="handleDelete"
                            componentId="payments-in-batch-list"
                    >
                        <payment-form-card
                                v-if="focusedPayment != null"
                                :payment="focusedPayment"
                                @save="handleSavePayment"
                                :enable-save="editable"
                        />
                    </data-table>

                </basic-card>
            </simple-layout>
        </simple-layout>
    </div>
</template>

<script>
    import BasicCard from "../components/layout/BasicCard";
    import FormTextInput from "../components/form/FormTextInput";
    import FormWrapper from "../components/form/FormWrapper";
    import FormDateInput from "../components/form/FormDateInput";
    import SimpleButton from "../components/button/SimpleButton";
    import DataTable from "../components/table/DataTable";
    import PaymentFormCard from "./PaymentFormCard";
    import SimpleLayout from "../components/layout/SimpleLayout";
    import {mapGetters} from "vuex";

    export default {
        name: "PaymentBatchFormCard",
        components: {
            SimpleLayout,
            PaymentFormCard, DataTable, SimpleButton, FormDateInput, FormWrapper, FormTextInput, BasicCard
        },
        props: {
            paymentBatch: {
                type: Object,
                default: () => ({states: []})
            }
        },
        computed: {
            ...mapGetters({
                paymentsByBatch: "paymentBatches/paymentsByBatch",
                account: "banking/account",
                actualUser: "auth/actualPrincipal",
                bank: "banking/bank",
                "accountBalances": "banking/accountBalances",
                "accounts": "banking/accounts"
            }),
            editable() {
                if (this.paymentBatch.id == undefined) return true;
                return (!['WAITING_FOR_PAYMENT', 'WAITING_FOR_APPROVAL', 'PAID'].includes(this.paymentBatch.states[this.paymentBatch.states.length - 1].type))
            },
            paymentsOverview() {
                let payments = this.paymentsByBatch(this.paymentBatch.id)
                let result = payments.reduce((acc, curr) => {
                    let currItem = acc.find(item => item.accountId == curr.sourceAccountRef.accountId)
                    if (currItem == undefined) {
                        let balances = this.accountBalances({id: curr.sourceAccountRef.accountId});
                        currItem = {
                            accountId: curr.sourceAccountRef.accountId,
                            balance: balances != undefined ? balances[0] : 0,
                            payments: 0
                        };
                        acc.push(currItem)
                    }
                    currItem.payments += curr.amount;
                    return acc;
                }, []);

                return result;
            }
        },
        methods: {
            handleFocusChanged(focused) {
                this.focusedPayment = focused;
            },
            getAccountById(id) {
                return this.accounts.find(acc => acc.id == id);
            },
            handleDelete(payment) {
                this.$store.dispatch('payments/deletePayment', payment).then(() => {
                    this.$store.dispatch("paymentBatches/loadPaymentsByBatch", {batchId: this.paymentBatch.id})
                });
                0
            },
            savePaymentBatch() {
                this.$emit('save', this.paymentBatch);
            },
            handleAdd() {
                this.focusedPayment = {
                    batchId: this.paymentBatch.id,
                    sourceAccountRef: {},

                    targetAccountRef: {},
                    czePaymentDetails: {},
                    foreignPaymentDetails: {
                        beneficiaryDetails: {}
                    },
                    realizationDetails: {}
                };
            },
            handleSavePayment(payment) {
                payment.sourceAccountRef.accountNumber = this.account(payment.sourceAccountRef.accountId).accountNumber;
                payment.targetAccountRef.accountNumber = this.account(payment.targetAccountRef.accountId).accountNumber;

                this.$store.dispatch('payments/savePayment', payment).then(() => {
                    this.$store.dispatch("paymentBatches/loadPaymentsByBatch", {batchId: this.paymentBatch.id}).then(() =>
                        this.focusedPayment = null)
                })
            }
        },
        mounted() {
            this.$store.dispatch("paymentBatches/loadPaymentsByBatch", {batchId: this.paymentBatch.id})
        },
        data: function () {
            return {
                focusedPayment: null,
                paymentsOverviewTableConfig: {
                    enableAdd: false,
                    allowEdit: false,
                    columns: [
                        {
                            caption: "Account",
                            datum: d => this.getAccountById(d.accountId).name
                        },
                        {
                            caption: "Account currency",
                            datum: d => this.getAccountById(d.accountId).currency
                        },
                        {
                            caption: "Actual balance",
                            datum: d => this.$formats.formatAmount(d.balance.endBalance / 100)
                        },
                        {
                            caption: "Payments total",
                            datum: d => this.$formats.formatAmount(d.payments / 1000000),
                        },
                        {
                            caption: "Funding",
                            datum: d => d.balance.endBalance < d.payments ? "Not enough funds" : "OK",
                            style: d => (d.balance.endBalance < d.payments ? { 'background-color': 'rgb(200, 74, 75)', color: 'white' } : undefined)
                        }
                    ]
                },
                paymentBatchWorkflowConfiguration: {
                    enableAdd: false,
                    allowEdit: false,
                    columns: [
                        {
                            caption: "Date",
                            datum: d => new Date(d.instant).toLocaleString()
                        },
                        {
                            caption: "Message",
                            datum: d => d.message
                        },
                        {
                            caption: "Target state",
                            datum: d => d.type
                        },
                        {
                            caption: "Username",
                            datum: d => d.userId
                        }
                    ]
                },
                paymentsTableConfiguration: {
                    enableAdd: true,
                    allowEdit: true,
                    columns: [
                        {
                            caption: "Date",
                            datum: d => this.$formats.formatDate(d.dueDate)
                        },
                        {
                            caption: "Amount",
                            datum: d => this.$formats.formatAmount(d.amount / 1000000)
                        },
                        {
                            caption: "Currency",
                            datum: d => d.currencyId
                        },
                        {
                            caption: "Account from",
                            datum: d => d.targetAccountRef != null && this.account(d.sourceAccountRef.accountId) != null ? this.account(d.sourceAccountRef.accountId).name : ""
                        },
                        {
                            caption: "Account to",
                            datum: d => d.targetAccountRef != null && this.account(d.targetAccountRef.accountId) != null ? this.account(d.targetAccountRef.accountId).name : ""
                        },
                        {
                            caption: "Payment state",
                            datum: d => d.states != undefined && d.states.length > 0 ? d.states[d.states.length - 1].type : "N/A"
                        }
                    ],
                    actions: [
                        {
                            icon: 'trash',
                            name: 'delete',
                            accessLambda: (entry) => this.editable,
                            tooltip: "Delete payment"
                        }
                    ]

                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>